import { ResizableHandle, ResizablePanel } from '@playbooks/ui/components/resizable'
import { Section } from '@playbooks/core/src/interfaces/ActionCard'
import { cn } from '@playbooks/ui/lib/utils'

import { useTranslation } from '../contexts/localization/Localization'
import Sections from './Sections'
import scrollABit from '../utils/scrollABit'
import { useAppContext } from '../contexts/AppContext'

export default function PinnedSections({
  sections,
  enabled,
  isRight,
}: {
  sections: Section[]
  enabled: boolean
  isRight: boolean
}) {
  const {
    settings: { pinnedPanelSize },
  } = useAppContext()

  const { text } = useTranslation()

  if (!enabled) return null

  const handleTouch = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const scrollContainer = e.currentTarget as HTMLDivElement

    // SetTimeout is needed to optimistically handle scroll after as the container change its scroll height
    // Because some element cab be conditionally hidden and appear in the interaction moment
    setTimeout(() => {
      const contentElement = scrollContainer.querySelector('[data-role="pinned-sections"]')!

      // Additional scroll if user interacts whit bottom part of the action card's pinned sections
      scrollABit(scrollContainer, contentElement, e.clientY)
    }, 100)
  }

  return (
    <>
      {isRight && <Handle />}
      <ResizablePanel minSize={200} defaultSize={`${pinnedPanelSize}%`}>
        <div
          id="AC_pinContainer"
          onClick={handleTouch}
          data-role="data-action-cards-sides-scroll-container"
          className={cn('w-full h-full overflow-auto scroll-smooth pb-25', isRight ? 'pr-2' : 'pl-2')}
        >
          <div data-role="pinned-sections">
            {sections.length ? (
              <Sections sections={sections} isPinnedView />
            ) : (
              <div className={'text-center text-zinc-500 text-[12px]'}>{text('noPinnedSections')}</div>
            )}
          </div>
        </div>
      </ResizablePanel>
      {!isRight && <Handle />}
    </>
  )
}

function Handle() {
  return (
    <ResizableHandle
      withHandle
      className={cn(
        '[&_div]:bg-transparent',
        '[&_div]:translate-x-1',
        'hover:[&_div]:bg-foreground',
        'bg-transparent',
        // -mx-2.5 ans w-3.5 make the grab area the same size.
        // Shadcn handles hovering the grab area sloppy. This is just a cosmetic adjustment.
        'w-3.5',
        '-mx-2.5',
        'focus-visible:outline-transparent',
        'focus-visible:ring-transparent',
        'focus-visible:ring-0',
      )}
    />
  )
}
